import {
  VuexModule,
  Mutation,
  Action,
  getModule,
  Module,
} from "vuex-module-decorators";

import store from "./index";
import StorageDb from "@/util/storage";
import { login, api_login } from "@/http/login";
import { Id } from "@/types/global";
import { addDynamicRoutes } from "@/router";
import router from "@/router";

interface mutation_login {
  username: string;
  token: string;
  id: Id;
  role: number;
  auth: string;
  main_auth: string;
}

@Module({
  name: "user",
  dynamic: true,
  namespaced: true,
  stateFactory: true,
  store,
})
export default class User extends VuexModule {
  private TOKEN: string | null = StorageDb.getLocal("token");
  private USERNAME: string | null = StorageDb.getLocal("username");
  private ROLE: number | null = StorageDb.getLocal("role");
  private ID: Id | null = StorageDb.getLocal("id");
  private PERMISSIONS: string = StorageDb.getLocal("permissions") || "";

  @Mutation
  private LOGIN({
    username,
    token,
    id,
    role,
    auth,
    main_auth,
  }: mutation_login) {
    this.USERNAME = username;
    this.TOKEN = token;
    this.ROLE = role;
    this.ID = id;
    this.PERMISSIONS = main_auth;
  }

  @Mutation
  private LOGOUT() {
    this.USERNAME = "";
    this.ROLE = null;
    this.TOKEN = null;
    this.ID = "";
    this.PERMISSIONS = "";
  }

  @Action({ rawError: true })
  public async login(info: login) {
    try {
      const loginInfo = await api_login.login(info);

      // 保存到本地存储
      StorageDb.setLocal("username", loginInfo.username);
      StorageDb.setLocal("role", Number(loginInfo.role));
      StorageDb.setLocal("token", loginInfo.token);
      StorageDb.setLocal("id", loginInfo.id);
      StorageDb.setLocal("permissions", loginInfo.main_auth);

      // 更新 store
      this.LOGIN({
        username: loginInfo.username,
        role: loginInfo.role,
        token: loginInfo.token,
        id: loginInfo.id,
        auth: loginInfo.auth,
        main_auth: loginInfo.main_auth,
      });

      // 初始化权限和路由
      addDynamicRoutes(loginInfo.main_auth);

      // 跳转到首页
      // 判断loginInfo.main_auth有没有包含home，有就跳转首页
      // 没有就跳转第一个有权限的页面
      if (
        loginInfo.main_auth.includes("home") ||
        loginInfo.main_auth.includes("*")
      ) {
        router.push("/home");
      }
      // router.replace("/home").catch((err) => {
      //   if (err.name !== "NavigationDuplicated") {
      //     console.error("Navigation error:", err);
      //   }
      // });
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  }

  @Action
  public logout() {
    StorageDb.removeLocal("username");
    StorageDb.removeLocal("role");
    StorageDb.removeLocal("token");
    StorageDb.removeLocal("id");
    StorageDb.removeLocal("permissions");
    StorageDb.removeLocal("auth");
    store.commit("setPermissions", "");
    this.LOGOUT();
  }

  // @Action
  // public async root_change(info: { id: Id }) {
  // 	const { username, token, id, role } = await api_login.root_change(info.id)
  // 	this.LOGIN({ username, role, token, id })
  // }

  public get token() {
    return this.TOKEN;
  }

  public get user_id() {
    return this.ID;
  }

  public get role() {
    return this.ROLE;
  }

  public get auth() {
    return this.PERMISSIONS;
  }

  public get user_info() {
    return {
      username: this.USERNAME,
    };
  }
}

export const UserModule = getModule(User);
